var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
import { greys } from "@irati/ui/src/global/colors";
import { Card } from "@irati/ui/src/Layout";
import padding from "@irati/ui/src/global/padding";
import image from "./no-results.png";
var ICON_SIZE = 90;
var NoResultsIcon = styled.img.attrs({
    alt: "no results",
    width: ICON_SIZE + "px",
    height: ICON_SIZE + "px",
    src: image
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.tiny);
var Wrapper = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: ", ";\n  padding: 55px;\n"], ["\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: ", ";\n  padding: 55px;\n"])), greys.light, padding.base);
var Paragraph = styled(Para)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  max-width: 360px;\n"], ["\n  color: ", ";\n  max-width: 360px;\n"])), greys.medium);
var NoResults = /** @class */ (function (_super) {
    __extends(NoResults, _super);
    function NoResults() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoResults.prototype.render = function () {
        return (React.createElement(Wrapper, null,
            React.createElement(NoResultsIcon, null),
            React.createElement(Para, { center: true },
                React.createElement(FormattedMessage, { id: "reward.catalogue.noresults.title" })),
            React.createElement(Paragraph, { center: true },
                React.createElement(FormattedMessage, { id: "reward.catalogue.noresults.body" }))));
    };
    return NoResults;
}(PureComponent));
export default NoResults;
var templateObject_1, templateObject_2, templateObject_3;
